import React from 'react';
import DirectorySearch from './DirectorySearch';

const SearchBrokers = () => <DirectorySearch type="broker" title="" />;

export default SearchBrokers;